import { SelectedItem } from '@galaxy/inventory-ui';
import { AppKey } from '@vendasta/marketplace-apps';

export function convertItemsToAppKeys(items: SelectedItem[]): AppKey[] {
  return items.map((item) => {
    return new AppKey({
      appId: item.itemId,
      editionId: item.type === 'app' ? item.edition?.editionId : undefined,
    });
  });
}

export function mapify(array: any[], keyFn: (item: any) => string): Map<string, any> {
  return array.reduce((map, item) => {
    map.set(keyFn(item), item);
    return map;
  }, new Map<string, any>());
}
